import { Message } from 'iview'
import { api } from '@/services'
const FETCH_LIST_REQUEST = 'FETCH_LIST_REQUEST'
const FETCH_LIST_FAILURE = 'FETCH_LIST_FAILURE'
const FETCH_LIST_SUCCESS = 'FETCH_LIST_SUCCESS'
export const state = {
  fetching: false,
  perList: [],
  personInfoList: [],
  pagination: {
    total: 0,
    pageNum: 0,
    pageSize: 15,
    timeFrom: '',
    timeTo: ''
  },
  showIM: false, // 是否显示im对话框
  showIMTime: '',
  intervalID: {}, // 显示聊天信息定时器对象
  checkedTagKey: '1',
  checkedTagType: 1,
  orderId: '',
  orderStatus: 1,
  headerUserRest: {
    status: 1,
    statusText: '',
    patientName: '',
    orderId: ''
  },
  historyCaseList: {
    mainSuit: '',
    treatIdea: '',
    ingHistoryIllness: '',
    previousHistory: '',
    historyObsterical: ''
  },
  xbkp: {
    xbkpUser: '',
    xbkpUserName: ''
  },
  templateBtns: {
    showMedicalTemplate: '', // 处方
    showCheckoutTemplate: '',// 检查
    showExamineTemplate: ''// 检验
  },
  // 该患者是否有诊断 以此判断 未填写病例页，未开诊断时开处方  0没有诊断  1或者其他有诊断
  isDiagnosis: 0,
  showSaveModal: false,
  imOnConnect: false,
  noGetReserveInfo: true,  //是否请求预约信息adminReserveInfo接口（曹妃甸诊所开方处的处理）

  // 取药方式存储
  drugTypeData: [],

  suggestdrugRouteStringDataCache: [],
  suggestfrequenceCodeStringDataCache: []
}
export const getters = {
  headerUserRest: state => state.headerUserRest,
  templateBtns: state => state.templateBtns,
  showIM: state => state.showIM,
  showIMTime: state => state.showIMTime,
  orderId: state => state.orderId,
  orderStatus: state => state.orderStatus,
  checkedTagKey: state => state.checkedTagKey,
  checkedTagType: state => state.checkedTagType,
  isDiagnosis: state => state.isDiagnosis,
  perList: state => state.perList,
  personInfoList: state => state.personInfoList,
  pagination: state => state.pagination,
  showSaveModal: state => state.showSaveModal,
  imOnConnect: state => state.imOnConnect,
  drugTypeData: state => state.drugTypeData,
  suggestdrugRouteStringDataCache: state => state.suggestdrugRouteStringDataCache,
  suggestfrequenceCodeStringDataCache: state => state.suggestfrequenceCodeStringDataCache,
  noGetReserveInfo: state => state.noGetReserveInfo
}

export const mutations = {
  [FETCH_LIST_REQUEST]: state => (state.fetching = true),
  [FETCH_LIST_FAILURE]: state => (state.fetching = false),
  [FETCH_LIST_SUCCESS]: (state, { data, pagination }) => {
    state.fetching = false
    state.perList = data
    if (pagination.pageNum == 0) {
      state.personInfoList = data.array
    } else {
      state.personInfoList.push(...data.array)
    }
    state.pagination = {
      ...state.pagination,
      ...pagination
    }
    state.headerUserRest = data.array[0]
    state.pagination.total = data.total
  },
  setsuggestdrugDataCache (state, data) {
    state.suggestdrugRouteStringDataCache = data.drugRoute
    state.suggestfrequenceCodeStringDataCache = data.drugFrequency
  },
  setimOnConnect (state, imOnConnect) {
    state.imOnConnect = imOnConnect
  },
  setShowSaveModal (state, showSaveModal) {
    state.showSaveModal = showSaveModal
  },
  setPersonInfoList (state, personInfoList) {
    state.personInfoList = personInfoList
  },
  setPaginationPerson (state, params) {
    state.pagination = params
    // state.pagination.pageNum = 0
  },
  setIsDiagnosis (state, isDiagnosis) {
    state.isDiagnosis = isDiagnosis
  },
  setcheckedTagType (state, checkedTagType) {
    // debugger
    state.checkedTagType = checkedTagType
  },
  setcheckedTagType (state, checkedTagType) {
    // debugger
    state.checkedTagType = checkedTagType
  },
  setNoGetReserveInfo (state, boo) {
    state.noGetReserveInfo = boo
  },
  setCheckedTagKey (state, checkedTagKey) {
    // debugger
    state.checkedTagKey = checkedTagKey
  },
  setHeaderUserRest (state, obj) {
    // debugger
    state.headerUserRest = {
      ...obj
    }
    state.orderId = obj.orderId === undefined ? '' : obj.orderId
  },
  setOrderStatus (state, status) {
    state.orderStatus = status
  },
  setHistoryCaseList (state, obj) {
    state.historyCaseList = obj
  },
  showImBox (state, isShow) {
    state.showIM = isShow
  },
  setXbkpObj (state, obj) {
    state.xbkp = obj
  },
  setTimer (state, obj) {
    state.intervalID = obj
  },
  setDrugTypeData (state, drugTypeData) {
    state.drugTypeData = drugTypeData
  },
  setBtnShow (state, obj) {
    state.templateBtns = obj
  }
}

export const actions = {
  async fetchOnlineDiagnoseList ({ commit, state }, params = {}) {
    if (state.fetching) {
      // state.fetching = false
      return Message.loading('请稍等，正在获取列表...')
    }
    commit(FETCH_LIST_REQUEST)
    const pagination = {
      pageNum: params.pageNum,
      pageSize: params.pageSize
    }
    if (params.pageNum === undefined) {
      pagination.pageNum = ~~state.pagination.pageNum + 1
    }
    if (params.pageSize === undefined) {
      pagination.pageSize = state.pagination.pageSize
    }
    const { success, data } = await api
      .adminOnlineDiagnoseList({
        data: { params: Object.assign({}, params, pagination) }
      })
      .catch(err => (commit(FETCH_LIST_FAILURE, err)))
    if (success) {
      commit(FETCH_LIST_SUCCESS, { data, pagination })
    } else {
      commit(FETCH_LIST_FAILURE)
    }
    return { success }
  },
  async fetchVideoChannelIdReport (state, params = {}) {
    params.channel_id = params.channelId
    params.order_id = state.state.headerUserRest.orderId
    const { success } = await api.videoChannelIdReport({
      data: { params: Object.assign({}, params) }
    })
    // .catch(err => {
    //   return Message.loading('服务器错误')
    // })

    return success
  },
  async putDurationReport (state, params = {}) {
    const { success } = await api.durationReport({
      data: { params: Object.assign({}, params) }
    })

    return success
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/privateConsultation.js